import React, { useCallback } from 'react';
import { StyleProp, ViewStyle } from 'react-native';

import { Carousel } from '@/components/Carousel';
import { Box } from '@/components/lib/components';
import { useResumeEffect } from '@/hooks/use-resume';
import { isWeb } from '@/utils/constants-platform-specific';

import { Promotion, usePromotions } from '../hooks/use-promotions';
import { PromoCard } from './PromoCard';

export const LobbyCarousel = ({ style }: { style?: StyleProp<ViewStyle> }) => {
    const { promotions, isLoading, goToPromo, refetch } = usePromotions();

    const reload = useCallback(() => {
        refetch();
    }, [refetch]);

    useResumeEffect(reload);

    const renderCarouselItem = useCallback(
        (item: Promotion) => {
            return (
                <PromoCard
                    key={item.uid}
                    promoId={item.uid}
                    segmented={item.data.segmented}
                    showOptInButton={item.bonusEngineDetails?.optInRequired ?? item.data.display_cta}
                    redirectPath={item.data.redirect_path ?? undefined}
                    title={item.data.title ?? ''}
                    imageUri={item.data.image.url ?? ''}
                    expirationTime={item.bonusEngineDetails?.expirationTime}
                    hasOptedIn={item.optedIn}
                    theme={item.data.promo_theme.data}
                    onPress={() => goToPromo(item.uid, item.data.external_url)}
                    secondaryButton={item.data.secondary_cta ?? undefined}
                />
            );
        },
        [goToPromo]
    );

    if (!isLoading && !promotions.length) {
        return null;
    }

    return (
        <Box style={style}>
            <Carousel<Promotion>
                data={promotions}
                isLoading={isLoading}
                showCarouselArrows={isWeb}
                renderCarouselItem={renderCarouselItem}
            />
        </Box>
    );
};
